/* Lumina Wear — CVR audit fixes (2026-09-26)
 * F2: no pre-selected size. Auto-select options that have only one value (e.g. a single colour),
 *     turn the Add-to-cart button into "Select a size" until a size is chosen, and on click scroll to
 *     and highlight the size row instead of silently adding XS.
 */
(function () {
  'use strict';

  var SELECT_TEXT = 'Select a size';

  function sizeSelectorOf(picker) {
    var fieldsets = picker.querySelectorAll('.option-selector');
    for (var i = 0; i < fieldsets.length; i++) {
      var name = (fieldsets[i].dataset.option || '').toLowerCase();
      if (name === 'size' || name === 'sizes') return fieldsets[i];
    }
    return null;
  }

  function missingSelectors(picker) {
    var out = [];
    picker.querySelectorAll('.option-selector').forEach(function (fs) {
      var radios = fs.querySelectorAll('input[type="radio"]');
      var select = fs.querySelector('select');
      if (radios.length) {
        var checked = false;
        radios.forEach(function (r) { if (r.checked) checked = true; });
        if (!checked) out.push(fs);
      } else if (select && !select.value) {
        out.push(fs);
      }
    });
    return out;
  }

  // Pre-select every option EXCEPT size (colour matches the featured image; single-value options too).
  // Size is the one choice the shopper must make deliberately.
  function autoSelectSingles(picker) {
    var sizeFs = sizeSelectorOf(picker);
    picker.querySelectorAll('.option-selector').forEach(function (fs) {
      if (fs === sizeFs) return;
      var radios = fs.querySelectorAll('input[type="radio"]');
      var anyChecked = false;
      radios.forEach(function (r) { if (r.checked) anyChecked = true; });
      if (radios.length && !anyChecked) {
        var pick = null;
        radios.forEach(function (r) { if (!pick && !r.classList.contains('is-unavailable')) pick = r; });
        pick = pick || radios[0];
        pick.checked = true;
        pick.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var select = fs.querySelector('select');
      if (select && !select.value && select.options.length) {
        select.selectedIndex = select.options[0].value ? 0 : Math.min(1, select.options.length - 1);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // Button keeps its normal 'Add to cart' label (Chev, 2026-09-27); it just must stay clickable while no size is picked,
  // so the click can scroll to and highlight the size row instead of being a dead disabled button.
  function labelButton(section) {
    var picker = section.querySelector('variant-picker');
    var btn = section.querySelector('.js-product-form [name="add"]');
    if (!picker || !btn || !btn.dataset.addToCartText) return;
    if (missingSelectors(picker).length && btn.textContent.trim() !== 'Sold out') {
      if (btn.disabled) btn.disabled = false;
      if (btn.textContent.trim() !== btn.dataset.addToCartText) btn.textContent = btn.dataset.addToCartText;
    }
  }

  function showMsg(picker, target) {
    var msg = picker.querySelector('.lumina-select-size-msg');
    if (!msg) {
      msg = document.createElement('span');
      msg.className = 'lumina-select-size-msg';
      msg.setAttribute('role', 'alert');
      (target || picker).appendChild(msg);
    }
    msg.textContent = 'Please choose your ' + ((target && target.dataset.option) ? target.dataset.option.toLowerCase() : 'options') + ' to continue.';
    picker.classList.add('lumina-attention');
    setTimeout(function () { picker.classList.remove('lumina-attention'); }, 2600);
  }

  function initSection(section) {
    var picker = section.querySelector('variant-picker');
    if (!picker || picker.dataset.luminaInit) return;
    picker.dataset.luminaInit = '1';

    autoSelectSingles(picker);
    labelButton(section);

    picker.addEventListener('change', function () {
      var msg = picker.querySelector('.lumina-select-size-msg');
      if (msg) msg.remove();
      // let the theme's own updateAddToCartButton run first
      setTimeout(function () { labelButton(section); }, 0);
    });

    function guard(evt, form) {
      var missing = missingSelectors(picker);
      var idInput = form.querySelector('input[name="id"]');
      if (missing.length || !idInput || !idInput.value) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        var target = missing[0] || sizeSelectorOf(picker) || picker;
        var top = target.getBoundingClientRect().top + window.pageYOffset - 140;
        window.scrollTo({ top: top, behavior: 'smooth' });
        showMsg(picker, missing[0] || sizeSelectorOf(picker));
        return true;
      }
      return false;
    }
    // click fires before native "required" validation, so we can scroll + highlight instead of the browser bubble
    section.addEventListener('click', function (evt) {
      var btn = evt.target.closest('.js-product-form [name="add"]');
      if (!btn) return;
      guard(evt, btn.form || btn.closest('form'));
    }, true);
    section.addEventListener('submit', function (evt) {
      var form = evt.target;
      if (!form.matches('.js-product-form')) return;
      guard(evt, form);
    }, true);

    // Re-label after the theme swaps dynamic content on variant change
    var obs = new MutationObserver(function () { labelButton(section); });
    var btnWrap = section.querySelector('.quantity-submit-row__submit');
    if (btnWrap) obs.observe(btnWrap, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    document.querySelectorAll('.section-main-product, [data-section-type="product"], .product-info, #product-info').forEach(function (el) {
      var section = el.closest('.shopify-section') || el;
      initSection(section);
    });
    document.querySelectorAll('.shopify-section').forEach(function (section) {
      if (section.querySelector('variant-picker') && section.querySelector('.js-product-form')) initSection(section);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  // Quick-buy / lazy-loaded product forms
  new MutationObserver(function () { init(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
